module.exports = __webpack_public_path__ + "img/img (5).32a69679.jpg";